export default __webpack_public_path__ + "static/media/O_GK_P1.249210e0.mp4";